import { OpponentPlayer, Player } from "./player.model";

export class Score {
   public points: number;
   public matchCount: number;
   public opponent: OpponentPlayer;
   constructor(data?: Partial<Score>) {
      Object.assign(this, data);
      if (data && data.opponent)
         this.opponent = new OpponentPlayer(data.opponent);
   }
}


export class AllScores {
   public levelId: number;
   public isDoubles: boolean;
   public nameLong: string;
   public nameShort: string;
   public scores: Score[];
   constructor(data?: Partial<AllScores>) {
      Object.assign(this, data);
      if (data && data.scores) {
         // this is weird... the assign will put the array into scores,
         // but as javascript data, not an object, so we can't call any methods
         // on the object... but if we don't clone it, the this.scores wipes
         //out the origin data value. ugh!
         const clone = JSON.parse(JSON.stringify(data));
         this.scores.length = 0;
         for (let s of clone.scores) {
            this.scores.push(new Score(s));
         }
      }
   }
}